import { useQuery } from '@apollo/client';
import { Result, Skeleton } from 'antd';
import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { VERIFY_INVITATION } from '../../apollo/common';
import CompleteProfile from '../../components/Doctor/CompleteProfile';

const StyledContent = styled.div`
  width: 700px;
  padding: 24px;
  background-color: #fff;
`;

const AcceptInvitation: FC = (): JSX.Element => {
  const { code } = useParams<{ code: string }>();
  const { data, loading } = useQuery(VERIFY_INVITATION, {
    variables: { code },
  });

  if (loading) {
    return <Skeleton active />;
  }

  if (!data?.verifyInvitation?.valid) {
    return <Result status="error" title="Invitation is already expired" />;
  }

  return (
    <StyledContent>
      <CompleteProfile
        email={data.verifyInvitation.email}
        code={code}
        name={`${data.verifyInvitation.firstName} ${data.verifyInvitation.lastName}`}
        type={data.verifyInvitation.type}
      />
    </StyledContent>
  );
};

export default AcceptInvitation;
